module.exports = __webpack_public_path__ + "static/media/gurugramwebp.22a55d04.webp";